import React, { useEffect } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  selectedProducts,
  removeSelectedProduct,
} from "./redux/actions/productActions";

const ProductDetails = (props) => {
  const product = useSelector((state) => state.product);
  const { image, price, category, title, discription } = product;
  const { productId } = props.match.params;
  const dispatch = useDispatch();
  console.log(product);

  useEffect(() => {
    const fetchProductDetails = async () => {
      const response = await axios
        .get(`https://fakestoreapi.com/products/${productId}`)
        .catch((err) => {
          console.log("Err", err);
        });
      dispatch(selectedProducts(response.data));
    };
    if (productId && productId !== "") fetchProductDetails();

    return () => {
      dispatch(removeSelectedProduct());
    };
  }, [productId, dispatch]);
  return (
    <div className="ui grid container">
      {Object.keys(product).length === 0 ? (
        <div>...Loading</div>
      ) : (
        <div className="ui placeholder segment">
          <div className="ui two column stackablr center aligned grid">
            <div className="ui vertical divider">AND</div>
            <div className="middle aligned row">
              <div className="column lp">
                <img className="ui fluid image" src={image} alt={discription} />
              </div>
              <div className="column rp">
                <h1>{title}</h1>
                <h2>
                  <button className="ui teal tag lable">${price}</button>
                </h2>
                <h3 className="ui broen block header">{category}</h3>
                <p>{discription}</p>
                <div className="ui vertical animated button" tableIndex="0">
                  <div className="hidden content">
                    <i className="shop icon"></i>
                  </div>
                  <div className="visible content">Add to Cart</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductDetails;
